import { useEffect } from 'react'

export const Loader = ({ onFinished }: { onFinished?: () => void }) => {
  useEffect(
    () => {
      return () => {
        onFinished?.()
      }
    },
    // onFinished should be called only once therefore we need to pass an empty
    // array
    []
  )

  return null
}
